<p-confirmDialog key="generateDadsCD" styleClass="delete-confirm-dialog" [baseZIndex]="10000"></p-confirmDialog>

<p-confirmDialog key="sendRemindersCD" styleClass="delete-confirm-dialog" [baseZIndex]="10000"></p-confirmDialog>
<div class="layout-main">
  <div class="container-fluid">
    <div class="row" style="margin-bottom: -2%">
      <div class="pb-2 mb-3 col-6 col-lg-6 col-md-6">
        <h2>
          <b>Market Data Access Declaration (DAD)</b>
        </h2>
      </div>
    </div>
    <hr>
    <div *ngIf="noSelectedDads" class="alert alert-warning alert-dismissible fade show" style="padding-top: 1%">
      Make sure to select at least one reported dad.
      <button (click)="noSelectedDads = false" aria-label="Close" class="close" type="button">
        <span aria-hidden="true" class="pull-right">&times;</span>
      </button>
    </div>
    <div *ngIf="successAlterAutoReport" class="alert alert-success alert-dismissible fade show">
      {{ alterAutoReportMessage }}
      <button (click)="successAlterAutoReport = false" aria-label="Close" class="close" type="button">
        <span aria-hidden="true" class="pull-right">&times;</span>
      </button>
    </div>
    <div *ngIf="generatedDadsMessage" class="alert alert-success alert-dismissible fade show">
      The dads list has been refreshed successfully.
      <button (click)="generatedDadsMessage = false" aria-label="Close" class="close" type="button">
        <span aria-hidden="true" class="pull-right">&times;</span>
      </button>
    </div>
    <div *ngIf="sendRemindersMessage" class="alert alert-success alert-dismissible fade show">
      Sending emails... You can leave this page.
      <button (click)="sendRemindersMessage = false" aria-label="Close" class="close" type="button">
        <span aria-hidden="true" class="pull-right">&times;</span>
      </button>
    </div>
    <div *ngIf="errorCsvReport" class="alert alert-danger">
      {{ errorMessageCsvReport }}
    </div>
    <div *roles="['ROLE_CLIENT_SUPER', 'ROLE_CLIENT_ADMIN', 'ROLE_CLIENT_DAD_REPORTER']" class="alert alert-info">
      For technical issues, please contact <a
      href="mailto:{{technicalIssueReportingEmail}}.">{{ technicalIssueReportingEmail }}</a>.<br>
      For any other question regarding Data Access Declaration, contact <a
      href="mailto:{{reportingEmail}}.">{{ reportingEmail }}</a>.
    </div>
    <p-tabView *roles="['ROLE_MCKAY_SUPER', 'ROLE_MCKAY_ADMIN', 'ROLE_MCKAY_DAD_REPORTER']"
               styleClass="dad-admin-tabs">
      <p-tabPanel header="DAD forms">
        <app-dad-forms-list (parentAvailableCompanyNames)=setAvailableCompanyNames($event) (parentNoSelectedDads)="alterNoSelectedDads($event)"
                            [exchangeNamesList]="exchangeNamesList"
                            [exchangesNames]="exchangesNames"></app-dad-forms-list>
      </p-tabPanel>
      <p-tabPanel header="Reports">
        <div class="dad-reports-tab">
          <div class="profile-toolbar dad-actions-toolbar">
            <div class="toolbar-group toolbar-group--warning">
              <button (click)="sendSecondReminder()" class="toolbar-btn" type="button">
                <i aria-hidden="true" class="fa fa-mail-reply-all"></i>
                Send reminder emails to clients
              </button>
            </div>
            <div class="toolbar-group toolbar-group--danger">
              <button (click)="generateDads()" class="toolbar-btn" type="button">
                <i aria-hidden="true" class="fa fa-refresh"></i>
                Generate all DADs for current usage month
              </button>
            </div>
          </div>

          <div class="report-cards">
            <app-dad-status [companiesItems]="availableCompanyNames"
                            [exchangeNamesList]="exchangeNamesList"></app-dad-status>

            <app-csv-report (errorCsvReport)="alterErrorCsvReport($event)"
                            (errorMessageCsvReport)="errorMessageCsvReport = $event"
                            [exchangeNamesList]="exchangeNamesList"></app-csv-report>

            <app-comparison-report [companiesItems]="availableCompanyNames"
                                   [exchangeNamesList]="exchangeNamesList"></app-comparison-report>

            <p-panel [toggleable]="true">
              <ng-template pTemplate="header">
                <div class="report-card-header">
                  <span class="report-icon"><i class="fa fa-download"></i></span>
                  <span class="report-card-title">Export Market data item list (CSV)</span>
                </div>
              </ng-template>
              <div class="report-card-body">
                <button (click)="exportDadItemsReport()" class="report-export-btn" icon="fa fa-download pr-2" iconPos="left"
                        label="Export Market data item list" pButton type="button"></button>
              </div>
            </p-panel>
          </div>
        </div>
      </p-tabPanel>
    </p-tabView>
    <ng-container *roles="['ROLE_CLIENT_SUPER', 'ROLE_CLIENT_ADMIN', 'ROLE_CLIENT_DAD_REPORTER']">
      <app-dad-forms-list (parentAvailableCompanyNames)=setAvailableCompanyNames($event) (parentNoSelectedDads)="alterNoSelectedDads($event)"
                          [exchangeNamesList]="exchangeNamesList"
                          [exchangesNames]="exchangesNames"></app-dad-forms-list>
    </ng-container>
  </div>
</div>
